import { Params } from './types';

export const getName = (params: Params) => {
  if (params.unlevered) return 'Bias Statistic (Unlevered)';
  return 'Bias Statistic';
};
